import { action } from 'typesafe-actions';

// Types
import { IntegrationFenceTypes, IntegrationFenceInterface } from './types';

// List Integration Fence
export const listIntegrationFenceRequest = (payload: { body?: object }) =>
  action(IntegrationFenceTypes.LIST_INTEGRATION_FENCES_REQUEST, payload);

export const listIntegrationFenceSuccess = (payload: {
  integrationFenceList: IntegrationFenceInterface[];
  totalCount: number;
}) => action(IntegrationFenceTypes.LIST_INTEGRATION_FENCES_SUCCESS, payload);

export const listIntegrationFenceFailure = () =>
  action(IntegrationFenceTypes.LIST_INTEGRATION_FENCES_FAILURE);

// Get Integration Fence
export const getIntegrationFenceRequest = (payload: object) =>
  action(IntegrationFenceTypes.GET_INTEGRATION_FENCE_REQUEST, payload);

export const getIntegrationFenceSuccess = (payload: {
  integrationFenceData: IntegrationFenceInterface;
}) => action(IntegrationFenceTypes.GET_INTEGRATION_FENCE_SUCCESS, payload);

export const getIntegrationFenceFailure = () =>
  action(IntegrationFenceTypes.GET_INTEGRATION_FENCE_FAILURE);

// Create Integration Fence
export const createIntegrationFenceRequest = (payload: object) =>
  action(IntegrationFenceTypes.CREATE_INTEGRATION_FENCE_REQUEST, payload);

export const createIntegrationFenceSuccess = (payload: {
  integrationFenceData: IntegrationFenceInterface;
}) => action(IntegrationFenceTypes.CREATE_INTEGRATION_FENCE_SUCCESS, payload);

export const createIntegrationFenceFailure = () =>
  action(IntegrationFenceTypes.CREATE_INTEGRATION_FENCE_FAILURE);

// Update Integration Fence
export const updateIntegrationFenceRequest = (payload: object) =>
  action(IntegrationFenceTypes.UPDATE_INTEGRATION_FENCE_REQUEST, payload);

export const updateIntegrationFenceSuccess = (payload: {
  integrationFenceData: IntegrationFenceInterface;
}) => action(IntegrationFenceTypes.UPDATE_INTEGRATION_FENCE_SUCCESS, payload);

export const updateIntegrationFenceFailure = () =>
  action(IntegrationFenceTypes.UPDATE_INTEGRATION_FENCE_FAILURE);

// Delete Integration Fence
export const deleteIntegrationFenceRequest = (payload: object) =>
  action(IntegrationFenceTypes.DELETE_INTEGRATION_FENCE_REQUEST, payload);

export const deleteIntegrationFenceSuccess = () =>
  action(IntegrationFenceTypes.DELETE_INTEGRATION_FENCE_SUCCESS);

export const deleteIntegrationFenceFailure = () =>
  action(IntegrationFenceTypes.DELETE_INTEGRATION_FENCE_FAILURE);
